export function setDatesToFullDayRange(campaignFields) {
		if (campaignFields.startDate != null) {
			campaignFields.startDate = campaignFields.startDate.clone().startOf('day')
		}

		if (campaignFields.endDate != null) {
			campaignFields.endDate = campaignFields.endDate.clone().endOf('day')
		}
}
